















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AlpacaCard from '@/components/AlpacaCard.vue';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import { EventBus } from '@/utils/EventBus';
import { validateAccount } from '@/utils/web3';
import { claim as woolClaim, contractAddress } from '@/contract/woolAirdrop';
import { canAdoptCount, adoptAlpaca, getPresaleAlpacaCount,
canAdoptCountWhite, adoptAlpacaWhite, getPresaleAlpacaCountWhite } from '@/contract/alpacaPresaleBSC';
import BigNumber from 'bignumber.js';
import AdoptCenter from '@/components/AdoptCenter.vue';
import { alpaUnit } from '@/utils/unit';
import AlpacaPreview from '@/components/AlpacaPreview.vue';
import { getAlpacaCount } from '@/backend/requests';
import { ROUTE_AIRDROP_TAB } from '@/router';
import { balanceOf } from '@/contract/woolToken';

@Component({
  components: {
    AlpacaCard,
    AlpacaBtn,
    AlpacaPreview,
    AdoptCenter,
  },
})
export default class Airdrop extends Vue {
  @Prop({
    required: false,
    default: 'whitelist',
  })
  public tab!: 'whitelist' | 'og';

  public curTab: 'whitelist' | 'og' = 'whitelist';
  // public canWoolClaim: boolean = false;
  public canAdoptCount: number = 0;
  public presaleRemaining: number = 0;
  public canAdoptCountWhite: number = 0;
  public presaleRemainingWhite: number = 0;
  public presaleRemainingWool: BigNumber = new BigNumber(0);

  get account() {
    return this.$store.getters.getAccount;
  }

  get canAdopt() {
    return this.canAdoptCount > 0 && this.presaleRemaining > 0;
  }

  get canWoolClaim() {
    return this.presaleRemainingWool.isGreaterThan(0);
  }

  get canAdoptWhite() {
    return this.canAdoptCountWhite > 0 && this.presaleRemainingWhite > 0;
  }

  public mounted() {
    this.curTab = this.tab;
  }

  public async connectWallet() {
    await validateAccount(this);
  }

  public async getPresaleRemainingWool() {
    const amount = await balanceOf(contractAddress!);
    if (amount) {
      this.presaleRemainingWool = new BigNumber(amount);
    }
  }

  // public async getCanWoolClaim() {
  //   const res = await canWoolClaim(this.account);
  //   if (res) {
  //     this.canWoolClaim = res;
  //   }
  // }

  public async getCanAdoptCount() {
    const res = await canAdoptCount(this.account);
    if (res) {
      return this.canAdoptCount = Number(res);
    }
  }

  public async getCanAdoptCountWhite() {
    const res = await canAdoptCountWhite(this.account);
    if (res) {
      return this.canAdoptCountWhite = Number(res);
    }
  }

  public async getPresaleAlpacaCount() {
    const amount = await getPresaleAlpacaCount();
    if (amount) {
      return this.presaleRemaining = Number(amount);
    }
  }

  public async getPresaleAlpacaCountWhite() {
    const amount = await getPresaleAlpacaCountWhite();
    if (amount) {
      return this.presaleRemainingWhite = Number(amount);
    }
  }

  public handleWoolClaim() {
    woolClaim(this.account);
  }

  public handleAdopt(count: number) {
    adoptAlpaca(this.account, count);
  }

  public handleAdoptWhite(count: number) {
    adoptAlpacaWhite(this.account, count);
  }

  public changeTab(tab: 'whitelist' | 'og') {
    this.curTab = tab;
    this.$router.push({ name: ROUTE_AIRDROP_TAB, params: {tab} });
  }

  @Watch('account', {immediate: true})
  public onAccount(val: string) {
    if (val) {
      this.getCanAdoptCount();
      this.getCanAdoptCountWhite();
      this.getPresaleAlpacaCount();
      this.getPresaleAlpacaCountWhite();
      // this.getPresaleRemainingWool();
    }
  }
}
